import { render, staticRenderFns } from "./ChatContent.vue?vue&type=template&id=3a7539f2&scoped=true&"
import script from "./ChatContent.vue?vue&type=script&lang=js&"
export * from "./ChatContent.vue?vue&type=script&lang=js&"
import style0 from "./ChatContent.vue?vue&type=style&index=0&id=3a7539f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7539f2",
  null
  
)

export default component.exports